import { docTypesDropdownAtom, themeAtom } from "../../shared/atoms";
import { useAtom, useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface DocumentTypesProps {
  types: string[];
}

export const DocumentTypes: React.FC<DocumentTypesProps> = ({ types }) => {
  const theme = useAtomValue(themeAtom);

  const [selectedDocTypes, setSelectedDocTypes] = useAtom(docTypesDropdownAtom);

  const toggleCheck = (docType: string): void => {
    const newValue = selectedDocTypes.includes(docType)
      ? selectedDocTypes.filter((v) => v !== docType)
      : [...selectedDocTypes, docType];
    setSelectedDocTypes(newValue);
  };

  const toggleForAll = (): void => {
    if (types.length === selectedDocTypes.length) {
      setSelectedDocTypes([]);
    } else {
      setSelectedDocTypes(types);
    }
  };

  return (
    <div
      className={twMerge(
        "border-1 absolute z-20 mt-1 w-[248px] rounded border shadow-[0_8px_16px_#45505229]",
        theme.certVesselSelect.tableBg,
        theme.certVesselSelect.tableBorder,
      )}
    >
      <div
        className={twMerge(
          "border-b-gray-80 flex w-full border-b px-4 py-3 text-sm",
          theme.certVesselSelect.tableBorder,
          theme.certVesselSelect.tableBg,
        )}
        onClick={toggleForAll}
      >
        <input
          type="checkbox"
          name={"All"}
          checked={types.length === selectedDocTypes.length}
          onChange={toggleForAll}
          className={twMerge("border", theme.certVesselSelect.tableBorder)}
        />
        <label htmlFor={"All"} className={theme.certVesselSelect.tableText}>
          {"All"}
        </label>
      </div>

      {types.map((docType: string) => {
        return (
          <div className={twMerge("flex w-full px-4 py-3 text-sm")} key={docType} onClick={() => toggleCheck(docType)}>
            <input
              type="checkbox"
              name={docType}
              checked={selectedDocTypes.includes(docType)}
              onChange={() => toggleCheck(docType)}
              className={twMerge("border", theme.certVesselSelect.tableBorder)}
            />
            <label htmlFor={docType} className={theme.certVesselSelect.tableText}>
              {docType}
            </label>
          </div>
        );
      })}
    </div>
  );
};
